"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ModelCompositorCrop {
    constructor(data) {
        this.id = data.id || -1;
        this.crop_name = data.crop_name || '';
        this.logo_name = data.logo_name || '';
        this.color = data.color || '';
    }
    getId() {
        return this.id;
    }
    getName() {
        return this.crop_name;
    }
    getLogoName() {
        return this.logo_name;
    }
    imgSrc(mode) {
        return `/crop/pic/${mode}/${this.logo_name}/Soil`;
    }
}
exports.default = ModelCompositorCrop;
